import React from 'react';
import { PageHeader } from '../components/PageHeader';
import { ServiceAreas } from '../components/ServiceAreas';
import { CallCta } from '../components/CallCta';
import { usePageMeta } from '../hooks/usePageMeta';
export function LocationsPage() {
  usePageMeta({
    title: "Service Areas & Locations | Mike's Pro Detail",
    description: "Mike's Pro Detail brings mobile car detailing to your home or office in Camarillo, Ventura, Thousand Oaks, Simi Valley, Moorpark, Newbury Park, Westlake Village and across Ventura County.",
    path: '/locations',
    breadcrumbName: 'Locations'
  });
  return <main data-id="element-1029" data-mp="12q7xy7qqb2w7">
      <PageHeader breadcrumb="Locations" title="Locations We Serve" subtitle="We're fully mobile — pick your city to see local details, or call to confirm we can come to you." data-id="element-1030" data-mp="12pemwukqlr89" />
      <ServiceAreas data-id="element-1031" data-mp="2e662pzevj2rm" />
      <CallCta data-id="element-1032" data-mp="2e4l8yc0dvnut" />
    </main>;
}